import React, { Dispatch, SetStateAction } from 'react';

import {
  Button,
  Create,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useNotify,
  useRefresh,
} from 'react-admin';

import { validRedemptionReasonChoices } from 'components/models/Offence/OffenceReasonField/mapping';
import { Modal } from 'components/molecules';

import {
  CREATE_REDEMPTION_FAILED_MSG,
  CREATE_REDEMPTION_SUCCESS_MSG,
  MODAL_OPEN_BUTTON_TEXT,
  MODAL_TITLE,
  REASON_INPUT_LABEL,
  STINTER_PROFILE_REF_INPUT_LABEL,
} from './RedemptionModal.constants';
import { RedemptionModalProps } from './RedemptionModal.types';
const validRedemptionReasonChoiceEntries = validRedemptionReasonChoices();

export const RedemptionModal = ({ stinterProfileId }: RedemptionModalProps) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const onSuccess = (setOpen: Dispatch<SetStateAction<boolean>>) => {
    setOpen(false);
    notify(CREATE_REDEMPTION_SUCCESS_MSG, 'info');
    refresh();
  };

  const onFailure = (setOpen: Dispatch<SetStateAction<boolean>>) => {
    setOpen(false);
    notify(CREATE_REDEMPTION_FAILED_MSG, 'error');
  };

  return (
    <Modal
      title={MODAL_TITLE}
      openComponent={
        <Button
          label={MODAL_OPEN_BUTTON_TEXT}
          color="primary"
          variant="contained"
          style={{
            padding: '0.5rem 2rem',
            marginTop: '1rem',
          }}
        />
      }
    >
      {({ setOpen }) => (
        <Create
          basePath="/Offence"
          resource="Offence"
          onSuccess={() => {
            onSuccess(setOpen);
          }}
          onFailure={() => {
            onFailure(setOpen);
          }}
        >
          <SimpleForm redirect={false} variant="filled" sanitizeEmptyValues>
            <TextInput
              label={STINTER_PROFILE_REF_INPUT_LABEL}
              source="createInputs.stinterProfileRef"
              defaultValue={stinterProfileId}
              disabled
              style={{
                display: 'none',
              }}
              data-testid="redemption-stint-profile-id"
            />

            <SelectInput
              choices={validRedemptionReasonChoiceEntries}
              label={REASON_INPUT_LABEL}
              source="createInputs.reason"
              validate={required()}
              data-testid="redemption-reason-id"
            />
          </SimpleForm>
        </Create>
      )}
    </Modal>
  );
};
